import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { GbiCode } from '../../../../types/CompanyScanTypes';
import GbiCodeInput from './GbiCodeInput';

interface Props {
  question: FlowsQuestion;
}

const GbiCodeInputComponent = ({ question }: Props) => {
  const {
    field: { value, onBlur },
  } = useFlowInputComponent({ question, defaultValue: [] });

  const gbiCodes = value as GbiCode[];

  const setGbiCodes = (gbiCodes: GbiCode[]) => {
    onBlur({
      name: question.id,
      value: gbiCodes,
    });
  };

  return (
    <GbiCodeInput
      value={gbiCodes}
      onChange={setGbiCodes}
      name={question.id}
      isDisabled={question.rules.is_disabled}
    />
  );
};

export default GbiCodeInputComponent;
